export const isMobilePhoneUserAgent = (userAgent?: string) => {
  const ua = userAgent || '';

  // iPads
  if (/iPad|iPad Mini|iPad Pro|iPad Air/i.test(ua)) {
    return false;
  }

  // Android tablets
  if (/Android(?=.*Tablet)|Android(?=.*Tab)/i.test(ua)) {
    return false;
  }

  // Other specific tablets
  if (
    /Tablet|PlayBook|Silk|Kindle|KFAPW|KFARWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFTHW|KFTHWA|KFTT|WFFOWI/i.test(
      ua
    )
  ) {
    return false;
  }

  // Samsung tablets
  if (/SM-T[0-9]{3,4}|GT-P|SM-P|Galaxy Tab/i.test(ua)) {
    return false;
  }

  // iOS phones
  if (/iPhone|iPod/i.test(ua)) {
    return true;
  }

  // Android phones (exclude tablets)
  if (/Android(?!.*Tablet)(?!.*Tab)/i.test(ua) && /Mobile/i.test(ua)) {
    return true;
  }

  // Windows phones
  if (/Windows Phone|IEMobile|WPDesktop/i.test(ua)) {
    return true;
  }

  // Other specific mobile phones
  if (
    /BlackBerry|BB10|RIM Tablet OS|webOS.*Mobile|Opera Mini|Opera Mobi/i.test(
      ua
    )
  ) {
    return true;
  }

  // Mobile Firefox, Chrome, and Safari
  if (
    (/Firefox/i.test(ua) || /Chrome/i.test(ua) || /Safari/i.test(ua)) &&
    /Mobile/i.test(ua) &&
    !/Tablet/i.test(ua)
  ) {
    return true;
  }

  // Generic mobile detection (but not tablet)
  if (
    /Mobile|Smartphone|Nokia|Symbian|SonyEricsson|SAMSUNG.*Mobile/i.test(ua) &&
    !/Tablet|Tab/i.test(ua)
  ) {
    return true;
  }

  return false;
};
